/**
 * Detects the running environment from the current hostname.
 *
 * Kept in its own dependency-free module so that `config` can use it without
 * importing `components/Utils` (which itself imports `config`), which would
 * create a circular import.
 *
 * TODO: need to be improved at some point, we should not rely on the hostname to determine the environment, but rather on a build-time variable.
 */
export const environment = () => {
	const hostname = window && window.location && window.location.hostname
	if (hostname === 'localhost' || hostname.includes('192.168')) {
		return 'development'
	} else if (hostname === 'dashboard.staging.spectre-music.com') {
		return 'staging'
	}
	return 'production'
}
